import { IMenu } from '@hooks/useMenu';
import { Menu, MenuProps } from '@material-ui/core';
import React from 'react';

export type RowMenuProps = Omit<MenuProps, "open" | "anchorEl"> & {
    menu: IMenu
}

export function RowMenu ({ menu, ...props }: RowMenuProps) {
    return (
        <Menu 
            {...props} 
            open={menu.isOpen} 
            onClose={menu.close}
            anchorEl={menu.anchorEl} 
        />
    )
}